export const MOBILE_MAX_WIDTH = 450;

export interface IGameSettings {
    altFootman: boolean;
    altLancer: boolean;
    altMarshal: boolean;
    aiMode: boolean;
	championsExpansion: boolean;
    choosePlayOrder: boolean;
    customUnitTypes: string[];
    customUnits: boolean;
    draftMode: boolean;
    draftType: string;
	highSeasExpansion: boolean;
    masteryExpansion: boolean;
    nobilityExpansion: boolean;
    ranked: boolean;
    royalGuardType: string;
    nightfallExpansion: boolean;
    siegeExpansion: boolean;
    shockExpansion: boolean;
    timeLimit: number;
    twoPlayersFullBoard?: boolean;
    blitz: number | null;
    altUnits: boolean;
    theme: string | null;
	allowedRanks: string[];
}

export interface IAppState {
    state: {
        gameSettings: IGameSettings;
        muted: boolean,
        volume: number;
        volumeLevel: number;
        showSrBanner: boolean;
        showReplayInstructions: boolean;
        dismissedAnnouncementIds: number[];
    };
    mutations: {

    };
    actions: {

    };
    getters: {

    };
}
